import { Layout as AntdLayout } from "antd";
import { createUseStyles } from "react-jss";

const { Content } = AntdLayout;

const useStyles = createUseStyles({
  content: {
    padding: "230px 48px" 
  },
  accessDeniedText: {
    minHeight: 50,
    padding: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize: 34,
    fontWeight: "bold",
  },
  contactAdminSubtext: {
    minHeight: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize: 20,
    fontWeight: "light",
  }
});

const ErrorAccessDenied = () => {

  const classes = useStyles();

  return (
    <AntdLayout>
      <Content className={classes.content}>
        <div className={classes.accessDeniedText}>
          Доступ запрещен! 
        </div>
        <div className={classes.contactAdminSubtext}>
          Свяжитесь с вашим системным администратором
        </div>
      </Content>
    </AntdLayout>
  );
};

export default ErrorAccessDenied;
